<template>
  <div class="detail">
    <h2>{{detail.title}}</h2>
    <span>{{setTime(detail.publishAt)}}</span>
    <video v-if="detail.video"></video>
    <div class="content" v-html="detail.cnt"></div>
  </div>
</template>

<script>
  import {
    news_detail
  } from '@/axios/api.js'
  import common from '@/assets/common.js'
  export default {
    data() {
      return {
        detail:{}
      }
    },
    methods: {
      setTime(str) {
        return common.time1(str)
      }
    },
    mounted() {
      var data = {
        id: this.$route.query.id
      }
      news_detail(data).then(res => {
        if (res.data.code == 0) {
          this.detail = res.data.obj;
        } else {
          this.$message(res.data.msg);
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
</script>
<style scoped="scoped">
  .detail{
    margin-top: 40px;
    text-align: center;
  }
  h2{
    font-weight: normal;
    font-size: 24px;
    line-height: 40px;
  }
  span{
    display: block;
    margin: 15px 0 35px;
  }
  .detail >>> p{
    font-size: 16px !important;
    line-height: 30px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/newsDetail.vue